module.exports = __webpack_public_path__ + "static/media/2b.f6d9efcf.jpg";